import { Component } from "react";
import { ShowBlocker, ShowCustomBlocker } from "../../Components/LoaderComponent/LoaderComponent";
import FormServices from "../../Services/FormServices";

interface IEligiblePlans {
  calculatedEMI: string
  emiMonths: string
  planName: string,
  eligible: boolean
}

interface IPlan {
  base64String: string,
  fileName: string,
  plans: IEligiblePlans[]
}

class EligiblePlans extends Component<{}, IPlan> {
  constructor(_props: any) {
    super(_props);
    this.state = {
      base64String: '',
      fileName: '',
      plans: []
    }
  }

  handleFileChange = (event: any) => {
    ShowBlocker(true);
    const file = event.target.files[0];

    if (file && file.type === "application/pdf") {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result;
        if (typeof result === "string") {
          this.setState({
            base64String: result.split(",")[1],
            fileName: file.name, // Store the file name
          }, () => {
            ShowBlocker(false)
          });
          // console.log("Base64:", reader.result);
        }

      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };
    } else {
      alert("Please upload a valid PDF file.");
      this.setState({ base64String: "", fileName: "" }); // Reset state if invalid file
    }
  };

  uploadPdf = () => {
    FormServices.UploadPDFToGetEligiblePlans({ base64String: this.state.base64String }).then((r) => {
      if (r.ok) {
        r.json().then(resp => {
          this.setState({ plans: resp });
        }, () => {
          console.log(this.state)
        });

      }
    })
  }

  renderEligiblePlans() {
    const eligiblePlans = this.state.plans.filter(plan => plan.eligible);

    if (eligiblePlans.length === 0) {
      return <p>No eligible plans available.</p>;
    }

    return (
      <table cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Plan Name</th>
            <th>EMI Amount</th>
            <th>Months</th>
            <th>Eligible</th>
          </tr>
        </thead>
        <tbody>
          {this.state.plans.map((plan, index) => (
            <tr key={index} style={{ backgroundColor: '#e6ffe6' }}>
              <td>{plan.planName}</td>
              <td>${Number(plan.calculatedEMI).toFixed(2)}</td>
              <td>{plan.emiMonths}</td>
              <td>{plan.eligible ? 'Yes' : 'No'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }


  render() {

    return (
      <><div style={{ display: 'flex', flexDirection: 'column', maxHeight: '500px', border: '0px solid', overflow: 'auto' }}>
        <div style={{ marginBottom: '10px' }}>
          <input type="file" accept="application/pdf" onChange={this.handleFileChange} />
          {this.state.fileName && <p><strong>File Name:</strong> {this.state.fileName}</p>}
          {this.state.base64String && <p>PDF converted to Base64 successfully!</p>}

        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginLeft: '20px' }}>
          <button onClick={this.uploadPdf}> Submit Question </button>
        </div>
        <div>
          <div>
            <h2 className="text-xl font-semibold">Tolling Events</h2>
            {this.renderEligiblePlans()}
          </div>
        </div>
      </div>
      </>

    );
  }

}

export default EligiblePlans;
